import React, { useEffect, useContext, useCallback } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import {
  Form,
  Grid,
  Button,
  Header,
  Icon,
  Image
} from 'semantic-ui-react'
import { AppContext } from './../../providers'
import {
  saveToLocalStorage,
  restoreFromLocalStorage
} from './../../utils/localStorage'
import coralLogo from './../../logo-coral.svg'
import coralDark from './../../logo-grey.svg'
import eightbitLogo from './../../logo-eightbit.svg'

const ManageThemes = () => {
  const { theme } = useParams()
  const navigate = useNavigate()
  const { beeAPI } = useContext(AppContext)
  const { dispatch } = beeAPI

  const selectCustomCss = (theme) => {
    const baseUrl = `${window.location.protocol}//${window.location.host}`
    switch (theme) {
      case 'coral':
        return `${baseUrl}/themes/coral.css`
      case 'dark':
        return `${baseUrl}/themes/dark.css`
      case 'eightbit':
        return `${baseUrl}/themes/eightbit.css`
      default:
        return ''
    }
  }

  const saveSettings = (value) => {

    const mergedConfig = {
      ...restoreFromLocalStorage('config'),
      customCss: selectCustomCss(value)
    }
    dispatch({
      payload: {
        theme: value,
        config: mergedConfig
      }
    })
    saveToLocalStorage(mergedConfig, 'config')
    saveToLocalStorage(value, 'theme')
  }

  const saveSettingsCallback = useCallback(saveSettings, [dispatch])

  useEffect(() => {
    if (theme) {
      saveSettingsCallback(theme)
    }
  }, [saveSettingsCallback, theme])

  const handleSwitchTheme = (theme) => {
    // Create a refresh to clear the previously saved CSS from DOM
    navigate(`/manage-themes/${theme}`)
    window.location.reload()
  }

  return (
    <>
      <Header as='h2'>
        <Icon name='paint brush' />
        <Header.Content>
          Theme settings
          <Header.Subheader>
            Choose a theme for the website and the editor
          </Header.Subheader>
        </Header.Content>
      </Header>
      <Grid divided='vertically'>
        <Grid.Row columns={1}>
          <Grid.Column>
            <Form>
              <Form.Field>
                <Button color="black" onClick={() => handleSwitchTheme('dark')}>
                  <Image size='medium' src={coralDark} style={{ 'height': '45px' }} />
                </Button>
                <Button onClick={() => handleSwitchTheme('coral')}>
                  <Image size='medium' src={coralLogo} style={{ 'height': '45px' }} />
                </Button>
                <Button onClick={() => handleSwitchTheme('eightbit')}>
                  <Image size='medium' src={eightbitLogo} style={{ 'height': '45px',  'fill':'purple'}} />
                </Button>
              </Form.Field>
            </Form>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </>
  )
}

export default ManageThemes
